import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="row-click"
export default class extends Controller {
  static values = {
    url: String,
    popup: Boolean
  }

  connect() {
  }
  // 親要素のdata-href属性にあるパスに遷移する
  toHref(event) {
    event.preventDefault()
    if (event.target.className === 'button'){
      if (event.target.id === 'confirm'){
        if(!confirm('削除を行いますか？')){
          return false;
        } else {
          event.target.form.submit()
        }
      } else {
        event.target.form.submit()
      }
    } else if (event.target.parentElement.className.includes('confirmButton')) {
      if(!confirm(event.target.parentElement.dataset.message)){
        return false;
      } else {
        event.target.parentElement.form.submit();
        event.target.parentElement.disabled = true;
      }
    } else if(event.target.tagName === 'A') {
      window.location.href = event.target.href
    } else {
      const href = this.urlValue || event.currentTarget.dataset['href']
      if (href) {
        if (this.popupValue) {
          window.open(href, '_blank', 'popup, noreferrer')
        } else {
          window.location.href = href
        }
      }
    }
  }

  // フォーカスした要素上でエンターを押した時、遷移する
  enterToHref(event) {
    if (event.target !== event.currentTarget) return

    if (event.key === 'Enter') {
      this.toHref(event)
    }
  }
}
